import { IUpdateAtividadeObraUseCase } from "../../../presentation/useCases/update/update_atividade_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateAtividadeObraUseCase
 */

export class UpdateAtividadeObraUseCase implements IUpdateAtividadeObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateAtividadeObra(
    idAtividadeObra: number,
    atividade: string,
    idFuncionarioResponsavel: number | null,
    funcionarioResponsavel: string | null,
    preencherResponsavel: boolean,
    idFuncionarioCorresponsavel: number | null,
    funcionarioCorresponsavel: string | null,
    preencherCorresponsavel: boolean,
  ): Promise<void> {
    const computedIdFuncionarioResponsavel = preencherResponsavel
      ? null
      : idFuncionarioResponsavel;

    const computedFuncionarioResponsavel = preencherResponsavel
      ? funcionarioResponsavel
      : null;

    const computedIdFuncionarioCorresponsavel = preencherCorresponsavel
      ? null
      : idFuncionarioCorresponsavel;

    const computedFuncionarioCorresponsavel = preencherCorresponsavel
      ? funcionarioCorresponsavel
      : null;

    await this.repository.updateAtividadeObra(
      idAtividadeObra,
      atividade,
      computedIdFuncionarioResponsavel,
      computedFuncionarioResponsavel,
      computedIdFuncionarioCorresponsavel,
      computedFuncionarioCorresponsavel,
    );
  }
}
